import type { Translations } from '../types';

export const ru: Translations = {
    identityVerification: {
        title: 'Подтвердите личность',
        mockNotice: 'Тестовый режим. Evrotrust не подключён. Документы личности и биометрия не собираются.',
        consent: 'Я понимаю, что это тестовая проверка, и согласен сохранить тестовый результат.',
        continue: 'Продолжить проверку',
        help: 'Если нужна помощь, обратитесь к представителю компании.',
        expires: 'Приглашение действительно до {date}',
        invalidTitle: 'Приглашение недоступно',
        invalidDescription:
            'Ссылка истекла, отозвана или больше недействительна. Обратитесь к представителю компании.',
        error: 'Не удалось выполнить запрос. Попробуйте ещё раз.',
        retry: 'Попробовать снова',
        loading: 'Загружаем приглашение…',
        successTitle: 'Проверка завершена',
        successDescription: 'Тестовый результат сохранён. Можно закрыть эту страницу.',
        roles: {
            admin: 'Директор',
            beneficiary: 'Бенефициар',
            beneficiary_admin: 'Директор и бенефициар',
        },
    },
    kyc: {
        title: 'Проверка документов',
        openSection: 'Открыть проверку документов',
        progress: 'Статус проверки',
        progressCount: 'Проверено {completed} из {total} обязательных этапов',
        refresh: 'Обновить',
        hint: 'Загрузите недостающие документы. Статусы обновляются по результатам проверки.',
        loading: 'Загрузка проверки…',
        retry: 'Повторить',
        empty: 'Сейчас нет доступных этапов. Обновите страницу позже или обратитесь в поддержку.',
        documents: 'Документы компании',
        identity: 'Проверка личности',
        otherChecks: 'Дополнительные проверки',
        rejectedHint: 'Проверка не пройдена. При необходимости обратитесь в поддержку.',
        openDocument: 'Открыть документ',
        upload: 'Загрузить файл',
        uploadAgain: 'Загрузить заново',
        uploading: 'Загрузка…',
        uploadSaved: 'Документ сохранён и передан на проверку.',
        continue: 'Продолжить',
        successTitle: 'Проверка компании завершена',
        successDescription: 'Все обязательные этапы проверки успешно пройдены.',
        done: 'Готово',
        statuses: {
            completed: 'Проверено',
            failed: 'Проверка не пройдена',
            in_progress_auto: 'Автоматическая проверка',
            in_progress_manual: 'На рассмотрении',
            upload: 'Необходимо загрузить',
            waiting: 'Ожидает проверки',
            notRequired: 'Не требуется',
        },
        errors: {
            emptyFile: 'Выбран пустой файл.',
            largeFile: 'Размер файла не должен превышать 10 МиБ.',
            invalidFile: 'Выберите PDF или изображение JPEG, PNG, GIF, BMP, WebP.',
            conflict: 'Состояние этапа изменилось. Данные обновляются; проверьте доступные действия.',
            upload: 'Не удалось подтвердить загрузку. Проверьте обновлённый список перед повторной отправкой.',
            load: 'Не удалось обновить данные проверки. Попробуйте ещё раз.',
        },
        stages: {
            kbo: {
                title: 'Выписка KBO',
                description: 'Данные компании из государственного реестра.',
            },
            company_charter: {
                title: 'Устав компании',
                description: 'Действующая редакция устава со всеми изменениями.',
            },
            ubo: {
                title: 'Реестр UBO',
                description: 'Сведения о бенефициарных владельцах компании.',
            },
            annual_report: {
                title: 'Годовой отчёт',
                description: 'Финансовая отчётность за последний закрытый год.',
            },
            admin_id: {
                title: 'Личность директоров',
                description: 'Общий статус проверки действующих директоров компании.',
            },
            beneficiaries: {
                title: 'Личность бенефициаров',
                description: 'Общий статус проверки бенефициарных владельцев.',
            },
            pep_individual: {
                title: 'Дополнительная проверка директоров',
                description: 'Проверка выполняется сотрудниками сервиса.',
            },
            pep_entity: {
                title: 'Дополнительная проверка компании',
                description: 'Проверка выполняется сотрудниками сервиса.',
            },
            risk_report: {
                title: 'Итоговое рассмотрение',
                description: 'Проверка выполняется сотрудниками сервиса.',
            },
            bank_account: {
                title: 'Банковские реквизиты',
                description: 'Общий статус проверки банковских реквизитов.',
            },
            other: {
                title: 'Дополнительная проверка',
                description: 'Статус проверки компании.',
            },
        },
    },
    common: {
        close: 'Закрыть',
        ok: 'Ок',
    },
    sidebar: {
        appTitle: 'Office Hof',
        menu: {
            mail: 'Почта',
            office: 'Офис',
            payment: 'Оплата',
            support: 'Поддержка',
            profile: 'Профиль',
            logout: 'Выйти',
        },
    },
    login: {
        title: 'Войти в личный кабинет',
        subtitle: 'Личный кабинет',
        loadingData: 'Загружаем ваши данные',
        form: {
            emailLabel: 'Логин',
            emailPlaceholder: 'Электронная почта',
            passwordLabel: 'Пароль',
            passwordPlaceholder: 'Введите пароль',
            rememberMe: 'Запомнить вход',
            rememberMeTooltip: 'Сохранить данные для входа на 3 месяца',
            submitButton: 'Войти',
            submitButtonLoading: 'Вход...',
            forgotPassword: 'Забыли пароль?',
            noAccountText: 'Нет аккаунта?',
            registerLink: 'Зарегистрироваться',
            forgotPasswordEmailSubject: 'Прошу сменить пароль',
            forgotPasswordEmailBody:
                'Прошу сменить пароль для учётной записи:\nemail: {email},\nкомпания: {company}.',
            forgotPasswordEmailRequiredTitle: 'Введите email',
            forgotPasswordEmailRequiredMessage:
                'Сначала введите email вашей учётной записи в поле выше, затем нажмите «Забыли пароль?».',
            selectCompany: 'Компания',
            passwordDisabledHint: 'Введите корректный email',
            recoveryTitle: 'Восстановление',
            loginLabel: 'Логин',
            companyLabel: 'Компания',
            newPasswordLabel: 'Ваш новый пароль',
            copyButton: 'Скопировать',
            savePasswordWarning: 'Запомните новый пароль!',
            recoveryFailedMessage: 'Не удалось восстановить доступ, попробуйте еще раз',
            backToLogin: 'Вернуться на логин',
            confirmRecoveryMessage: 'Подтвердите восстановление аккаунта',
            confirmRecoveryButton: 'Подтвердить',
        },
        validation: {
            emailRequired: 'Введите email адрес',
            emailInvalid: 'Введите корректный email адрес',
            passwordRequired: 'Введите пароль',
            incorrectCredentials: 'Неверный логин или пароль',
            userNotFound: 'Пользователь не найден',
        },
        errors: {
            authError: 'Ошибка авторизации',
            invalidCredentials: 'Неверный логин или пароль',
            tooManyAttempts: 'Слишком много попыток, попробуйте позже',
            logoutError: 'Не удалось выйти из системы',
        },
    },
    registration: {
        title: 'Регистрация',
        emailLabel: 'Электронная почта',
        emailPlaceholder: 'Введите ваш email',
        continueButton: 'Продолжить',
        haveAccount: 'Уже есть аккаунт?',
        signInLink: 'Войти',
        confirmTitle: 'Подтверждение электронной почты',
        confirmMessage: 'Введите код, который мы отправили на почту {email}',
        confirmBack: 'Назад',
        changeEmail: 'Указать другой email',
        confirmSpamHint: 'Не пришел код? Проверьте папку "Спам".',
        confirmRequestAgainIn: 'Еще раз запросить код можно через: {time}',
        confirmRequestAgainButton: 'Запросить повторно',
        validation: {
            emailRequired: 'Введите email',
            emailInvalid: 'Введите корректный email',
        },
        errors: {
            invalidEmail: 'Невалидный email',
            rateLimit: 'Слишком много попыток. Попробуйте позже.',
            serverError: 'Ошибка на сервере, попробуйте позже.',
            wrongCode: 'Неверный код',
        },
        form: {
            stepSelectTariff: 'Выберите тариф',
            stepCompanyDetails: 'Заполните данные о вашей компании',
            stepAddressDetails: 'Заполните ваш почтовый адрес',
            addressForwardingHint: 'На этот адрес будет осуществлятся пересылка бумажных писем и посылок',
            stepPersonalDetails: 'Заполните ваши личные данные',
            stepComplete: 'Готово!',
            next: 'Далее',
            back: 'Назад',
            finish: 'Готово',
            stepSelectTariffStub: 'Здесь будет форма выбора тарифа.',
            stepCompanyDetailsStub: 'Здесь будут поля с данными о вашей компании.',
            stepPersonalDetailsStub: 'Здесь будут поля с вашими личными данными.',
            stepCompleteStub: 'Регистрация завершена. Нажмите «Готово», чтобы перейти ко входу.',
            loadingRegCustomerData: 'Загружаем данные',
            selectOfficeLabel: 'Выберите офис',
            selectTariffLabel: 'Выберите тариф',
            officeBrussels: 'Брюссель',
            officeFlanders: 'Фландрия',
            companyNameLabel: 'Название компании',
            companyNamePlaceholder: 'Введите название компании',
            activityLabel: 'Деятельность',
            activityPlaceholder: 'Опишите деятельность компании',
            innLabel: 'ИНН',
            innPlaceholder: 'Введите ИНН',
            promoCodeLabel: 'Промокод',
            promoCodePlaceholder: 'Введите промокод',
            ifAvailable: 'если есть',
            tariffDetailsLink: 'Подробнее о тарифах',
            registrationFor: 'Регистрация для',
            firstNameLabel: 'Имя',
            firstNamePlaceholder: 'Введите имя',
            lastNameLabel: 'Фамилия',
            lastNamePlaceholder: 'Введите фамилию',
            countryLabel: 'Страна',
            countryPlaceholder: 'Выберите страну',
            cityLabel: 'Город',
            cityPlaceholder: 'Введите город',
            lineLabel: 'Улица и дом',
            linePlaceholder: 'Введите улицу и дом',
            postcodeLabel: 'Почтовый индекс',
            postcodePlaceholder: 'Введите почтовый индекс',
            countryBelgium: 'Бельгия',
            countryFrance: 'Франция',
            countryGermany: 'Германия',
            countryNetherlands: 'Нидерланды',
            countryPoland: 'Польша',
            genderLabel: 'Пол',
            genderMale: 'Мужской',
            genderFemale: 'Женский',
            personalAddressLabel: 'Адрес',
            personalAddressPlaceholder: 'Введите адрес',
            phoneLabel: 'Телефон',
            phonePlaceholder: 'Введите телефон',
            passportFileLabel: 'Скан паспорта',
            uploadPassportFrontButton: 'Загрузить лицевую',
            uploadPassportReverseButton: 'Загрузить обратную',
            uploadAnotherPassportFileButton: 'Выбрать другой файл',
            passportReverseFileLabel: 'Обратная сторона паспорта',
            passportFrontSideLabel: 'Лицевая сторона паспорта',
            openUploadedFile: 'Открыть файл',
            completeRegistrationTitle: 'Подтвердите регистрацию',
            completeRegistrationMessage: 'После подтверждения заполненная форма отправится на модерацию.',
            completeRegistrationConfirmButton: 'Подтвердить',
            completeRegistrationCancelButton: 'Отмена',
            completeValidationFieldsTitle: 'Проверьте следующие поля:',
            completeValidationFieldError: 'Проверьте это поле',
            completeValidationInnHint: 'Проверьте поле ИНН на шаге данных компании',
            moderationInProgressTitle: 'Ваши данные на проверке',
            moderationInProgressDescription:
                'Проверка занимает до 24 часов. После завершения мы отправим на вашу почту {email} письмо с логином и паролем для входа в личный кабинет.',
            moderationInProgressContact: 'Если у вас возникли вопросы, свяжитесь с нами:',
            returnToWebsiteButton: 'Вернуться на сайт',
            registerButton: 'Зарегистрироваться',
            requiredField: 'Обязательное поле',
            minLengthTemplate: 'Минимум {n} символа',
            maxLengthTemplate: 'Максимум {n} символов',
            phoneInvalid: 'Телефон может содержать только цифры, + и скобки',
            latinOnly: 'Используйте только латинские символы',
        },
    },
    pages: {
        mail: {
            title: 'Почта',
            forwardToHomeAddress: 'Настроить перессылку писем на мой домашний адрес',
            forwardToHomeAddressDescription: 'Все письма будут автоматически пересылаться на указанный адрес',
            configureForwarding: 'Настроить пересылку',
            incomingMailSettings: 'Настройки сканирования писем',
            openQrCode: 'QR-код ключ к Office Hof',
            orderForwarding: 'Заказать пересылку писем',
            forwarding: 'Пересылка бумажных писем',
            orderForwardingTitle: 'Заказать пересылку писем',
            orderOneTimeForwarding: 'Заказать единоразовую пересылку',
            orderForwardingMessage:
                'Закажите пересылку писем и мы отправим все ваши письма из офиса Hof на ваш адрес',
            orderButton: 'Заказать',
            orderForwardingSuccess: 'Пересылка заказана',
            orderForwardingError: 'Ошибка при заказе пересылки',
            forwardingSentMessage: 'Письма пересланы на ваш адрес. Подтвердите получение.',
            forwardingSentHint: 'Если в течение 10 дней письма не пришли, обратитесь в поддержку',
            forwardingTrackNumber: 'Трек-номер',
            forwardingTrackOnBpost: 'Отследить на bpost',
            forwardingReceivedButton: 'Пересылку получил',
            forwardingReceivedSuccess: 'Получение пересылки подтверждено',
            forwardingReceivedError: 'Ошибка при подтверждении получения',
            forwardingEmptyMessage: 'Пересылка отменена, так как ящик был пуст на момент запроса',
            singleForwardingStatus: {
                processing: 'В обработке',
                completed: 'Завершена',
                pending: 'Ожидает',
                cancelled: 'Отменена',
                sent: 'Отправлено',
            },
            singleForwardingRequestDate: 'Дата запроса',
            singleForwardingStatusLabel: 'Статус',
            cancelButton: 'Отмена',
            qrCodeTitle: 'Персональный QR код',
            qrCodeDescription:
                'По этому QR-коду вы можете получить доступ к офису, к забронированным переговорным и вашему почтовому ящику',
            qrCodeDescriptionWithAddress:
                'По этому QR-коду вы можете получить доступ к офису по адресу {address}, к забронированным переговорным и вашему почтовому ящику',
            scanContent: 'Сканировать содержимое письма',
            scanContentDescription: 'Автоматически сканировать содержимое входящих писем',
            scanningSettings: 'Настройка сканирования',
            scanningSettingsPaperStorageTooltip:
                'Бумажные оригиналы писем будут храниться в вашем личном ящике, внутри офисного центра.',
            scanningDescription:
                'Если в целях конфиденциальности вы не желаете, чтобы ваши письма были вскрыты и отсканированы нашим сотрудникам, отключите нижестоящую функцию. Оповещение о поступлении почты будет приходить бесплатно.',
            forwardingSettings: 'Настройка пересылки',
            regularForwarding: 'Регулярная пересылка',
            oneTimeForwarding: 'Единоразовая пересылка',
            forwardMail: 'Пересылать письма',
            forwardNever: 'Никогда',
            forwardOncePerMonth: 'Раз в месяц',
            forwardTwicePerMonth: 'Два раза в месяц',
            forwardingDescription: 'Пересылка входящей почты будет на ваш домашний адрес: {address}',
            changeAddressHint: 'Для смены адреса напишите в поддержку',
            changeAddressButton: 'Сменить адрес',
            forwardingInfo: 'Вы можете настроить регулярную пересылку либо заказать единоразово',
            sendRegisteredMail: 'Отправлять заказным письмом',
            settingsSaved: 'Настройки сохранены',
            saveError: 'Ошибка при сохранении настроек',
            mailsList: 'Список писем',
            noMails: 'Писем нет',
            loading: 'Загрузка...',
            loadError: 'Ошибка загрузки писем',
            unavailable: 'Недоступно',
            mailTypeLetter: 'Письмо',
            mailTypeLetterNoScan: 'Письмо (не сканировалось)',
            mailTypeParcel: 'Посылка',
            parcelTypeSmall: 'Малая',
            letterNoScanModalTitle: 'Письмо не сканировалось',
            letterNoScanModalMessage:
                'Ваши бумажные письма хранятся в Office Hof, вы можете забрать их сами или заказать пересылку по почте.',
            letterNoScanOrderButton: 'Заказать пересылку',
            parcelTypeBig: 'Большая',
            viewButton: 'Посмотреть',
            downloadButton: 'Скачать',
            paymentHintButton: 'Подсказка',
            paymentRequiredTitle: 'Требуется оплата',
            paymentRequiredMessage: 'Для просмотра письма необходимо оплатить новый период',
            payButton: 'Оплатить',
            searchByDate: 'Искать по дате',
            thisWeek: 'Эта неделя',
            thisMonth: 'Этот месяц',
            parcelReceivedTitle: 'Вам пришла {type} посылка',
            parcelReceivedBig: 'большая',
            parcelReceivedSmall: 'маленькая',
            parcelPickupAddress: 'Забрать можно в офисе по адресу',
            okButton: 'Ок',
            dateFrom: 'От',
            dateTo: 'До',
            resetButton: 'Сбросить',
            applyButton: 'Применить',
            dateFromAfterTo: 'Дата "От" не может быть позднее "До"',
            dateToBeforeFrom: 'Дата "До" не может быть раньше "От"',
            clearFilter: 'Сбросить фильтр',
        },
        office: {
            title: 'Офис-центр',
            inDevelopment: 'В разработке',
            meetingRooms: 'Переговорные',
            meetingRoomsDescription: 'Бронирование и управление переговорными комнатами',
            coworking: 'Коворкинг',
            coworkingDescription: 'Бронирование коворкинга',
            noCoworkingAvailable: 'Нет доступных мест в коворкинге',
            capacity: 'Вместимость',
            people: 'чел.',
            fromPrice: 'От',
            perHour: 'в час',
            includingVat: 'НДС включён',
            exclVat: 'без НДС',
            book: 'Забронировать',
            location: 'Локация',
            selectLocation: 'Выберите локацию',
            allLocations: 'Все локации',
            noRoomsAvailable: 'Нет доступных переговорных',
            myBookings: 'Мои бронирования',
            noBookings: 'У вас пока нет бронирований',
            bookingQrModalTitle: 'Доступ к переговорной',
            bookingQrModalMessage: 'Для доступа к переговорной предъявите QR-код',
            rooms: {
                charlemagne: {
                    name: '"Charlemagne" (Green)',
                    description:
                        'Оборудование: Медиа проектор, доска и маркеры, аудиосистема, телефон для конференций. Дополнительные услуги: Кофе, чай и вода предлагаются бесплатно во время бронирования.',
                },
                ambiorix: {
                    name: '"Ambiorix" (Red)',
                    description:
                        'Оснащена LED проектором и дисплеем, доской и маркерами, аудиосистемой, телефоном для конференций. Дополнительные услуги: Кофе, чай и вода предлагаются бесплатно во время бронирования.',
                },
            },
            showQrCode: 'Показать QR-код',
            hours: 'ч',
            minutes: 'мин',
            datePlaceholder: 'дд.мм.гггг',
            duration: 'Продолжительность',
            cost: 'Стоимость',
            insufficientFundsTitle: 'Недостаточно средств',
            insufficientFundsMessage: 'У вас недостаточно средств',
            insufficientFundsMessageWithAmount:
                'У вас недостаточно средств для бронирования. На балансе не хватает €{amount}',
            showMore: 'Еще',
            hide: 'Скрыть',
            booking: 'Бронирование',
            selectDate: 'Выберите дату',
            noSlotsAvailable: 'Нет доступных слотов',
            roomNotSelected: 'Не указана переговорная комната',
            available: 'Свободно',
            booked: 'Забронировано',
            bookingSuccess: 'Успешно забронировали переговорную',
            bookingError: 'Ошибка при создании бронирования',
            startTime: 'Начало',
            endTime: 'Конец',
            selectStartTime: 'Выберите время',
            selectEndTime: 'Выберите время',
        },
        payment: {
            title: 'Оплата',
            showContract: 'Договор с Office Hof',
            balance: 'Баланс',
            extraChargesThisMonth: 'Списания за доп. услуги в этом месяце',
            extraChargesSectionTitle: 'Списания в этом месяце за доп услуги',
            extraServiceTypes: {
                scan: 'Сканирование писем',
                parcels: 'Пересылка писем/посылок',
                bookings: 'Бронирование переговорных',
                tariff: 'Тариф',
                postal_fees: 'Почтовые сборы',
            },
            extraChargesTotalLabel: 'Итого',
            tariff: 'Тариф',
            nextChargeDate: 'Следующее списание: ',
            tariffNotActivated: 'Тариф активируется после оплаты',
            replenishBalance: 'Пополнить баланс',
            replenish: 'Пополнить',
            pay: 'Оплатить',
            paySubscriptionTitle: 'Оплатите подписку',
            paySubscriptionMessage: 'Страница будет доступна после оплаты подписки',
            availableAfterPrepayment: 'Доступно после предоплаты',
            enterAmount: 'Введите сумму и выберите тип оплаты',
            paymentCredited:
                'Обычно платеж зачисляется сразу, но в некоторых случаях зачисление может занять до 2 суток',
            paymentScreenTitle: 'Оплата',
            enterAmountForPayment: 'Введите сумму для оплаты',
            amountForPayment: 'Сумма для оплаты',
            replenishBalanceOn: 'Пополнить баланс на:',
            totalToPay: 'Итого к оплате:',
            payByRequisites: 'Оплатить по реквизитам',
            requisiteCompany: 'Компания',
            payOnline: 'Оплатить онлайн',
            payFor1Month: 'Оплатить за 1 месяц',
            payFor3Months: 'Оплатить за 3 месяца',
            payFor6Months: 'Оплатить за пол года',
            payFor12Months: 'Оплатить за год',
            discount: 'Скидка',
            discountOnTariff: 'Скидка {discount}% на тариф на {months} месяцев!',
            discountOnTariffTooltip:
                'При оплате на сумму €{amount}, Вы получите скидку {discount}% на оплату тарифа в течение {months} месяцев!',
            customAmount: 'Своя сумма',
            minAmountError: 'Минимальная сумма для оплаты: {amount}€',
            serverError: 'Ошибка сервера, уже разбираемся',
            chargesHistory: 'История списаний',
            invoice: 'Фактура от',
            noInvoices: 'Фактуры не найдены',
            noTariff: 'У вас нет тарифа',
            currentTariff: 'Текущий',
            sameAsPreviousTariff: 'Всё из {tariffName}, а ещё:',
            fromPrice: 'От',
            perMonth: 'в месяц',
            withoutVat: 'без НДС 21%',
            goToTariff: 'Сменить тариф',
            tariffUpgradeSubject: 'Запрос от клиента {customer_id} обновить тариф до {tariff_name}',
            tariffUpgradeBody: 'Прошу повысить мой тариф до {tariff_name}',
            tariffFeatures: {
                legalAddress: 'Юридический адрес Вашей компании',
                receptionMails: 'Прием Ваших входящих писем (заказных в т.ч.) и пакетов',
                coffeeSoftDrinks:
                    'Кофе и безалкогольные напитки для Вас и Ваших клиентов в переговорной комнате',
                access24_7: 'Доступ к Вашей информации и сообщениям 24 часа в сутки 7 дней в неделю',
                sharedFaxLine: 'Общая линия входящих факсов (рассматривается как обычная почта)',
                mailScanning:
                    'Сканирование входящей почты и перенаправление ее в Ваш почтовый ящик на ежедневной основе',
                freePages:
                    'Количество бесплатных листов (сканирование и перенаправление в Ваш почтовый ящик A4 с 2 сторон), включенных в месячный абонемент',
                personalBox: 'Персональный ящик для хранения документов, доступ 24/7',
                ipTelephony: 'Услуга IP-телефонии, включая расширение в IP-АТС "Office Hof"',
                freeMeetingHours: 'Количество часов бесплатного бронирования конференц-залов в месяц',
                freeParcels: 'Количество бесплатных входящих посылок, включенных в месячный абонемент',
                discountLevel:
                    'Уровень скидок на бронирование конференц-залов и рабочих мест, сканирование почты и обработку посылок',
                brusselsPhoneLine:
                    'Брюссельская прямая телефонная линия (также доступны номера линий для разных областей и стран) через IP PBX',
                phoneCallsManagement:
                    'Управление входящими и исходящими телефонными звонками и факсами с помощью выделенной IP-АТС',
            },
        },
        support: {
            title: 'Свяжитесь с поддержкой',
            phone: 'Телефон',
            email: 'Email',
            phoneHint: '9:00–18:00, будни',
            writeButton: 'Написать в поддержку',
            emailSubject: 'Заявка от клиента {customer_id}',
            editDataEmailSubject: 'Запрос на изменение данных от клиента {customer_id}',
            innEmailSubject: 'Информация от клиента {customer_id}',
            innEmailBody: 'Здравствуйте!\n\nМой ИНН: \n',
            innModalTitle: 'Необходимо сообщить ИНН',
            innModalMessage: 'Пожалуйста, укажите ваш ИНН — мы передадим его на проверку.',
            innModalSubmitButton: 'Отправить',
            innModalLaterButton: 'Позже',
            innModalCloseButton: 'Закрыть',
            innRequiredModalTitle: 'Необходимо сообщить ИНН',
            innRequiredModalMessage:
                'Отведённые на сообщение ИНН {n} дней истекли. Укажите ИНН ниже, чтобы продолжить пользоваться сервисом.',
            innInputLabel: 'ИНН',
            innInputPlaceholder: 'Введите ИНН',
            innInputRequired: 'Укажите ИНН',
            innResubmitButton: 'Отправить повторно',
            innPendingTitle: 'ИНН на проверке',
            innPendingMessage:
                'Мы получили ваш ИНН {tax_id} и передали его на проверку. Пока проверка не завершена, доступ к сервису ограничен.',
            innPendingResubmitHint:
                'Проверка занимает больше времени, чем обычно. Вы можете отправить ИНН повторно.',
            innSubmitError: 'Не удалось отправить ИНН. Попробуйте ещё раз позже.',
            innButton: 'Сообщить ИНН',
            loading: 'Загрузка...',
            copied: 'Скопировано в буфер обмена',
        },
        recovery: {
            title: 'Восстановление',
            description: 'Для восстановления доступа к аккаунту {email} нажмите кнопку ниже.',
            descriptionWithCompany:
                'Для восстановления доступа к аккаунту {email} компании {company_name} нажмите кнопку ниже.',
            button: 'Восстановить',
            successMessage: 'Отправили вам на почту письмо с ссылкой для восстановления.',
            successHint: 'Если письмо не пришло попробуйте позже еще раз.',
            invalidEmail: 'Неверный email',
        },
        profile: {
            title: 'Профиль',
            companyData: 'Данные компании',
            contactPerson: 'Контактное лицо',
            mailingAddress: 'Адрес для пересылки писем',
            settings: 'Настройки',
            companyName: 'Название',
            inn: 'ИНН',
            officeAddress: 'Адрес офиса',
            name: 'Имя',
            email: 'Email',
            phone: 'Телефон',
            interfaceLanguage: 'Язык интерфейса',
            editData: 'Редактировать данные',
            editDataMessage: 'Для изменения ваших данных или данных компании обратитесь в поддержку',
            logoutButton: 'Выйти',
            loading: 'Загрузка данных профиля...',
            languageNames: {
                ru: 'Русский',
                en: 'English',
                fr: 'Français',
                nl: 'Nederlands',
                de: 'Deutsch',
            },
        },
    },
    installPrompt: {
        title: 'Установить приложение',
        description: 'Установите приложение для более быстрого и удобного доступа к услугам Office Hof',
        install: 'Установить',
        skip: 'Пропустить',
        androidTitle: 'Установка на Android',
        androidSteps: [
            'Откройте меню браузера (три точки вверху справа)',
            'Выберите «Установить приложение» или «Добавить на главный экран»',
            'Подтвердите установку',
        ],
        iosTitle: 'Установка на iPhone',
        iosSteps: [
            'Нажмите кнопку «Поделиться» (квадрат со стрелкой вверх) в Safari',
            'Прокрутите и выберите «На экран „Домой“»',
            'Нажмите «Добавить»',
        ],
        close: 'Закрыть',
    },
};
